import { endTenderDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const endTenderCallable = getCallable(endTenderDefinition);
